import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_materials_by_base_packaging_grid_ComponentContextService } from './FootprintManager.materials_by_base_packaging_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Materials_material_statuses_dd_singleComponent } from './Materials.material_statuses_dd_single.component'
import { Materials_material_groups_dd_singleComponent } from './Materials.material_groups_dd_single.component'
import { Materials_allocation_strategies_dd_singleComponent } from './Materials.allocation_strategies_dd_single.component'
import { Materials_allocation_strategy_workflows_dd_singleComponent } from './Materials.allocation_strategy_workflows_dd_single.component'


interface IFootprintManager_materials_by_base_packaging_gridComponentEntity {
  MaterialId?: number, PackagingId?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Material?: { Id?: number, AllocationStrategyId?: number, AllocationStrategyWorkflowId?: string, ControllerTypeId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, Name?: string, ProjectId?: number, ShelfLifeSpan?: number, StatusId?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, ControllerType?: { Id?: number, Name?: string }, GlobalMaterial?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string }, Status?: { Id?: number, Name?: string }, AllocationStrategy?: { Name?: string } }, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }}

interface IFootprintManager_materials_by_base_packaging_gridComponentInParams {
  projectId?: number, ownerId?: number}


class FootprintManager_materials_by_base_packaging_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_materials_by_base_packaging_gridComponent;
  entity: IFootprintManager_materials_by_base_packaging_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    description_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    material_status_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    material_group_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    allocation_strategy_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    allocation_strategy_workflow_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    lot_controlled_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    serial_controlled_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    serial_controlled_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_weight_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_volume_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_dimension_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_dimension_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    upc_code_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shelf_life_span_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    lookupcode: null,
    description: null,
    packaging_short_name: null,
    source_catalog: null,
    owner: null,
    project: null,
    material_status_name: null,
    material_group_name: null,
    allocation_strategy: null,
    allocation_strategy_workflow: null,
    lot_controlled: null,
    serial_controlled: null,
    is_fixed_weight: null,
    is_fixed_volume: null,
    is_fixed_dimension: null,
    length: null,
    width: null,
    height: null,
    weight: null,
    shipping_weight: null,
    volume: null,
    shipping_volume: null,
    pallet_high: null,
    pallet_tie: null,
    upc_code: null,
    shelf_life_span: null,
    ready_to_ship: null,
  }

  get $fields_allocation_strategy_workflow_selector_inParams_is_active(): boolean {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = true;
    
    return expr;
  }


  constructor(
    grid: FootprintManager_materials_by_base_packaging_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.description = new GridCellModel(
      new CellStyles(['left'], null),
      this.grid.headers.description,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['description_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.packaging_short_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging_short_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.source_catalog = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.source_catalog,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.owner,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_status_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_status_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['material_status_name_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.material_group_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_group_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['material_group_name_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.allocation_strategy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.allocation_strategy,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['allocation_strategy_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.allocation_strategy_workflow = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.allocation_strategy_workflow,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['allocation_strategy_workflow_edit'] as DatexFormControl, 
        ESelectBoxType.dropdown, null,
        false,
        false,
        '', null)
      );
    
    this.cells.lot_controlled = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot_controlled,
      new CheckBoxModel(this.formGroup.controls['lot_controlled_display'] as DatexFormControl, null, true, false, '', null)
,
null
      );
    
    this.cells.serial_controlled = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.serial_controlled,
      new CheckBoxModel(this.formGroup.controls['serial_controlled_display'] as DatexFormControl, null, true, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['serial_controlled_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.is_fixed_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_fixed_weight,
      new CheckBoxModel(this.formGroup.controls['is_fixed_weight_display'] as DatexFormControl, null, true, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_weight_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.is_fixed_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_fixed_volume,
      new CheckBoxModel(this.formGroup.controls['is_fixed_volume_display'] as DatexFormControl, null, true, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_volume_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.is_fixed_dimension = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_fixed_dimension,
      new CheckBoxModel(this.formGroup.controls['is_fixed_dimension_display'] as DatexFormControl, null, true, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_dimension_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.shipping_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.shipping_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_volume,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.pallet_high = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_high,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_high_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.pallet_tie = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_tie,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_tie_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.upc_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.upc_code,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['upc_code_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.shelf_life_span = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shelf_life_span,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shelf_life_span_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.ready_to_ship = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ready_to_ship,
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_display'] as DatexFormControl, null, false, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_materials_by_base_packaging_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_materials_by_base_packaging_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagingId',this.entity.PackagingId);
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  null ,
    };
    const data = await this.$datasources.Materials.ds_materials_by_base_packaging_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_materials_by_base_packaging_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.description.displayControl as TextModel).text = $row.entity.Material?.Description;
    (this.cells.description.editControl as TextBoxModel).reset($row.entity.Material?.Description);
    (this.cells.packaging_short_name.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.material_status_name.displayControl as TextModel).text = $row.entity.Material?.Status?.Name;
    (this.cells.material_status_name.editControl as SelectBoxModel).reset($row.entity.Material.StatusId);
    (this.cells.material_group_name.displayControl as TextModel).text = $row.entity.Material?.MaterialGroup?.Name;
    (this.cells.material_group_name.editControl as SelectBoxModel).reset($row.entity.Material.MaterialGroupId);
    (this.cells.allocation_strategy.displayControl as TextModel).text = $row.entity.Material?.AllocationStrategy?.Name;
    (this.cells.allocation_strategy.editControl as SelectBoxModel).reset($row.entity.Material.AllocationStrategyId);
    (this.cells.allocation_strategy_workflow.editControl as SelectBoxModel).reset($row.entity?.Material?.AllocationStrategyWorkflowId);
    (this.cells.serial_controlled.displayControl as CheckBoxModel).reset($row.entity.Material.ControllerTypeId == 3 || $row.entity.Material.ControllerTypeId == 4 ? true : false);
    (this.cells.serial_controlled.editControl as CheckBoxModel).reset($row.entity.Material.ControllerTypeId == 3 || $row.entity.Material.ControllerTypeId == 4 ? true : false);
    (this.cells.is_fixed_weight.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedWeight);
    (this.cells.is_fixed_weight.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedWeight);
    (this.cells.is_fixed_volume.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedVolume);
    (this.cells.is_fixed_volume.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedVolume);
    (this.cells.is_fixed_dimension.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedLength);
    (this.cells.is_fixed_dimension.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedLength);
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.weight.editControl as NumberBoxModel).reset($row.entity.Weight);
    (this.cells.shipping_weight.displayControl as TextModel).text = $row.entity.ShippingWeight?.toString();
    (this.cells.shipping_weight.editControl as NumberBoxModel).reset($row.entity.ShippingWeight);
    (this.cells.volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.volume.editControl as NumberBoxModel).reset($row.entity.Volume);
    (this.cells.shipping_volume.displayControl as TextModel).text = $row.entity.ShippingVolume?.toString();
    (this.cells.shipping_volume.editControl as NumberBoxModel).reset($row.entity.ShippingVolume);
    (this.cells.pallet_high.displayControl as TextModel).text = $row.entity.PalletHigh?.toString();
    (this.cells.pallet_high.editControl as NumberBoxModel).reset($row.entity.PalletHigh);
    (this.cells.pallet_tie.displayControl as TextModel).text = $row.entity.PalletTie?.toString();
    (this.cells.pallet_tie.editControl as NumberBoxModel).reset($row.entity.PalletTie);
    (this.cells.upc_code.displayControl as TextModel).text = $row.entity.UpcCode;
    (this.cells.upc_code.editControl as TextBoxModel).reset($row.entity.UpcCode);
    (this.cells.shelf_life_span.displayControl as TextModel).text = $row.entity.Material?.ShelfLifeSpan?.toString();
    (this.cells.shelf_life_span.editControl as NumberBoxModel).reset($row.entity.Material.ShelfLifeSpan);
    (this.cells.ready_to_ship.displayControl as CheckBoxModel).reset($row.entity.UseAsShippingContainer);
    (this.cells.ready_to_ship.editControl as CheckBoxModel).reset($row.entity.UseAsShippingContainer);

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootprintManager_materials_by_base_packaging_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  let payload: any = {};
  
  if ($row.cells.is_fixed_weight.editControl.isChanged
      || $row.cells.is_fixed_dimension.editControl.isChanged
      || $row.cells.is_fixed_volume.editControl.isChanged
      || $row.cells.serial_controlled.editControl.isChanged
  ) {
  
      const inventory = (await $datasources.Materials.ds_get_licenseplatecontents_by_materialId_top1.get({
          materialId: $row.entity.MaterialId
      })).result;
      if (!$utils.isDefined(inventory)) {
          payload.IsFixedWeight = $row.cells.is_fixed_weight.editControl.value;
          payload.IsFixedLength = $row.cells.is_fixed_dimension.editControl.value;
          payload.IsFixedVolume = $row.cells.is_fixed_volume.editControl.value;
  
          if ($row.cells.serial_controlled.editControl.isChanged) {
              const currentControllerTypeId = $row.entity.Material.ControllerTypeId;
              var controllerTypeId;
              if (currentControllerTypeId === 1) {
                  controllerTypeId = 3
              }
              if (currentControllerTypeId === 2) {
                  controllerTypeId = 4
              }
              if (currentControllerTypeId === 3) {
                  controllerTypeId = 1
              }
              if (currentControllerTypeId === 4) {
                  controllerTypeId = 2
              }
              payload.ControllerTypeId = controllerTypeId
          }
      }
      else {
          var errorMessage = ''
          errorMessage += 'Material currently contains inventory, cannot change Fixed weight, fixed dimension, fixed volume and or serial controlled options.';
          $shell.Materials.showErrorDetails('Save', 'Error on save.', errorMessage);
          throw errorMessage; // to prevent displayMode 
  
      }
  
  
  }
  // Future code to handle changing lot controlled property. Make sure to handle controller type change while accounting for serial controlled change.
  
  
  if ($row.cells.allocation_strategy.editControl.isChanged) {
      payload.AllocationStrategyId = $row.cells.allocation_strategy.editControl.value;
  }
  if ($row.cells.description.editControl.isChanged) {
      payload.Description = $row.cells.description.editControl.value;
  }
  if ($row.cells.material_group_name.editControl.isChanged) {
      payload.MaterialGroupId = $row.cells.material_group_name.editControl.value;
  }
  if ($row.cells.shelf_life_span.editControl.isChanged) {
      payload.ShelfLifeSpan = $row.cells.shelf_life_span.editControl.value;
  }
  if ($row.cells.material_status_name.editControl.isChanged) {
      payload.StatusId = $row.cells.material_status_name.editControl.value;
  }
  
  
  let payloadpackaging: any = {};
  
  if ($row.cells.length?.editControl.isChanged) {
      payloadpackaging.Length = $row.cells.length?.editControl.value;
  }
  if ($row.cells.width?.editControl.isChanged) {
      payloadpackaging.Width = $row.cells.width?.editControl.value;
  }
  if ($row.cells.height?.editControl.isChanged) {
      payloadpackaging.Height = $row.cells.height?.editControl.value;
  }
  if ($row.cells.weight?.editControl.isChanged) {
      payloadpackaging.Weight = $row.cells.weight?.editControl.value;
  }
  if ($row.cells.shipping_weight?.editControl.isChanged) {
      payloadpackaging.ShippingWeight = $row.cells.shipping_weight?.editControl.value;
  }
  if ($row.cells.volume?.editControl.isChanged) {
      payloadpackaging.Volume = $row.cells.volume?.editControl.value;
  }
  if ($row.cells.shipping_volume?.editControl.isChanged) {
      payloadpackaging.ShippingVolume = $row.cells.shipping_volume?.editControl.value;
  }
  if ($row.cells.pallet_high?.editControl.isChanged) {
      payloadpackaging.PalletHigh = $row.cells.pallet_high?.editControl.value;
  }
  if ($row.cells.pallet_tie?.editControl.isChanged) {
      payloadpackaging.PalletTie = $row.cells.pallet_tie?.editControl.value;
  }
  if ($row.cells.upc_code?.editControl.isChanged) {
      payloadpackaging.UpcCode = $row.cells.upc_code?.editControl.value;
  }
  if ($row.cells.ready_to_ship?.editControl.isChanged) {
      payloadpackaging.UseAsShippingContainer = $row.cells.ready_to_ship?.editControl.value;
  }
  
  try {
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Materials', id: $row.entity.Material.Id, entity: payload });
  
  
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'MaterialsPackagingsLookup',
          entity: payloadpackaging,
          pk1String: 'MaterialId',
          pk1: $row.entity.Material.Id,
          pk2String: 'PackagingId',
          pk2: $row.entity.PackagingId
      });
  
  
      await $row.refresh();
  
  }
  
  catch (error) {
      $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootprintManager_materials_by_base_packaging_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  var ControllerTypeId = $row.entity.Material?.ControllerTypeId;
  
  $row.cells.allocation_strategy_workflow.displayControl.text = $grid.vars.allocationStrategyWorkflows.find(w => w.Id.trim().toLowerCase() === $row.entity.Material.AllocationStrategyWorkflowId?.trim()?.toLowerCase())?.Name;
  
  if (ControllerTypeId === 1) {
      $row.cells.lot_controlled.displayControl.value = false;
      $row.cells.serial_controlled.displayControl.value = false;
  
  }
  if (ControllerTypeId === 2) {
      $row.cells.lot_controlled.displayControl.value = true;
      $row.cells.serial_controlled.displayControl.value = false;
  
  }
  if (ControllerTypeId === 3) {
      $row.cells.lot_controlled.displayControl.value = false;
      $row.cells.serial_controlled.displayControl.value = true;
  
  }
  if (ControllerTypeId === 4) {
      $row.cells.lot_controlled.displayControl.value = true;
      $row.cells.serial_controlled.displayControl.value = true;
  
  }
  // Apply custom project string logic
  if ($row.entity.Material?.Project?.LookupCode === $row.entity.Material?.Project?.Name) {
      $row.cells.project.displayControl.text = $row.entity.Material?.Project?.LookupCode
  } else {
      $row.cells.project.displayControl.text = $row.entity.Material?.Project?.LookupCode + ' ' + $row.entity.Material?.Project?.Name
  }
  
  // Apply custom owner string logic
  if ($row.entity.Material?.Project?.Owner?.LookupCode === $row.entity.Material?.Project?.Owner?.Name) {
      $row.cells.owner.displayControl.text = $row.entity.Material?.Project?.Owner?.LookupCode
  } else {
      $row.cells.owner.displayControl.text = $row.entity.Material?.Project?.Owner?.LookupCode + ' ' + $row.entity.Material?.Project?.Owner?.Name
  }
  
  
  // Material catalog feature
  let versionCheck = await $flows.Utilities.check_footprint_version({ minimumVersion: '24.10.25' });
  
  if (versionCheck.meetsMinimumVersion) {
  
      // @ts-ignore 
      const material_catalog_details = (await $datasources.Catalogs.ds_get_material_catalog_details_by_material_id.get({ material_id: $row.entity.MaterialId })).result;
      if ($utils.isDefined(material_catalog_details) && $utils.isDefined(material_catalog_details[0]?.MaterialCatalogSourceMaterialId)) {
  
          $row.cells.source_catalog.displayControl.text = material_catalog_details[0].MaterialCatalog?.Name;
  
          for (let cell in $row.cells) {
              if ($row.cells[cell]?.editControl?.readOnly != undefined) {
                  $row.cells[cell].editControl.readOnly = true;
              }
          }
  
  
      }
  }
  
  }
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootprintManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootprintManager_materials_by_base_packaging_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.MaterialId});
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Materials_material_statuses_dd_singleComponent),
    forwardRef(() => Materials_material_groups_dd_singleComponent),
    forwardRef(() => Materials_allocation_strategies_dd_singleComponent),
    forwardRef(() => Materials_allocation_strategy_workflows_dd_singleComponent),
  ],
  selector: 'FootprintManager-materials_by_base_packaging_grid',
  templateUrl: './FootprintManager.materials_by_base_packaging_grid.component.html'
})
export class FootprintManager_materials_by_base_packaging_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_materials_by_base_packaging_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('fixedWidth', ['compact','set-width-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_materials_by_base_packaging_gridComponentInParams = { projectId: null, ownerId: null };


  //#region Variables
  vars: { allocationStrategyWorkflows?: { Id: string, Name: string }[] } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Material', false, false, 100, false),       description: new GridHeaderModel(new HeaderStyles(['left'], null), 'description', 'Description', false, false, 300, false),       packaging_short_name: new GridHeaderModel(new HeaderStyles(null, null), 'packaging_short_name', 'Base packaging', false, false, 100, false),       source_catalog: new GridHeaderModel(new HeaderStyles(null, null), 'source_catalog', 'Source catalog', false, false, 100, false),       owner: new GridHeaderModel(new HeaderStyles(null, null), 'owner', 'Owner', false, false, 100, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, 100, false),       material_status_name: new GridHeaderModel(new HeaderStyles(null, null), 'material_status_name', 'Status', false, false, 100, false),       material_group_name: new GridHeaderModel(new HeaderStyles(null, null), 'material_group_name', 'Group', false, false, 100, false),       allocation_strategy: new GridHeaderModel(new HeaderStyles(null, null), 'allocation_strategy', 'Allocation strategy', false, false, 100, false),       allocation_strategy_workflow: new GridHeaderModel(new HeaderStyles(null, null), 'allocation_strategy_workflow', 'Allocation strategy', false, false, 100, false),       lot_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'lot_controlled', 'Lot controlled', false, false, 100, false),       serial_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'serial_controlled', 'Serial controlled', false, false, 100, false),       is_fixed_weight: new GridHeaderModel(new HeaderStyles(null, null), 'is_fixed_weight', 'Fixed weight', false, false, 100, false),       is_fixed_volume: new GridHeaderModel(new HeaderStyles(null, null), 'is_fixed_volume', 'Fixed volume', false, false, 100, false),       is_fixed_dimension: new GridHeaderModel(new HeaderStyles(null, null), 'is_fixed_dimension', 'Fixed dimension', false, false, 100, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, 100, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, 100, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, 100, false),       weight: new GridHeaderModel(new HeaderStyles(null, null), 'weight', 'Weight', false, false, 100, false),       shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_weight', 'Shipping weight', false, false, 100, false),       volume: new GridHeaderModel(new HeaderStyles(null, null), 'volume', 'Volume', false, false, 100, false),       shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_volume', 'Shipping volume', false, false, 100, false),       pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_high', 'Pallet high', false, false, 100, false),       pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_tie', 'Pallet tie', false, false, 100, false),       upc_code: new GridHeaderModel(new HeaderStyles(null, null), 'upc_code', 'UPC', false, false, 100, false),       shelf_life_span: new GridHeaderModel(new HeaderStyles(null, null), 'shelf_life_span', 'Shelf life', false, false, 100, false),       ready_to_ship: new GridHeaderModel(new HeaderStyles(null, null), 'ready_to_ship', 'Shippable container', false, false, 100, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_materials_by_base_packaging_gridComponentRowModel[] = [];

  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }

  topToolbar = {
      update: new ToolModel(new ButtonModel('update', new ButtonStyles(null, null), false, false, false, 'Update', 'icon-ic_fluent_arrow_clockwise_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      on_delete: new ToolModel(new ButtonModel('on_delete', new ButtonStyles(null, null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Materials';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  null ,
    };
    try {
      const data = await this.$datasources.Materials.ds_materials_by_base_packaging_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_materials_by_base_packaging_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_materials_by_base_packaging_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_materials_by_base_packaging_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete(event = null) {
    return this.on_deleteInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_deleteInternal(
    $grid: FootprintManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.Materials.openErrorDialog('Material Delete Error', 'No materials selected.');
      return;
  } else {
      const candidates = [];
      const failures = [];
      const errors = [];
  
      let material_ids = selectedRows.map(r => r.entity.Material.Id);
  
      const result = await $flows.Materials.is_material_deletable_flow({ material_ids: material_ids });
      const reason = result.reason;
  
      let material_ids_not_deletable: number[] = [];
  
      if ($utils.isDefined(result?.have_contents)) {
          errors.push(...selectedRows.filter(s => result.have_contents.indexOf(s.entity.Material.Id) >= 0 && material_ids_not_deletable.indexOf(s.entity.Material.Id) === -1).map(s => `Material ${s.entity.Material.LookupCode} has contents.`));
          material_ids_not_deletable.push(...result?.have_contents);
      }
      if ($utils.isDefined(result?.have_tasks)) {
          errors.push(...selectedRows.filter(s => result.have_tasks.indexOf(s.entity.Material.Id) >= 0 && material_ids_not_deletable.indexOf(s.entity.Material.Id) === -1).map(s => `Material ${s.entity.Material.LookupCode} has tasks.`));
          material_ids_not_deletable.push(...result?.have_tasks);
      }
      if ($utils.isDefined(result?.have_lines)) {
          errors.push(...selectedRows.filter(s => result.have_lines.indexOf(s.entity.Material.Id) >= 0 && material_ids_not_deletable.indexOf(s.entity.Material.Id) === -1).map(s => `Material ${s.entity.Material.LookupCode} has lines.`));
          material_ids_not_deletable.push(...result?.have_lines);
      }
  
      const valid_rows = selectedRows.filter(s => material_ids_not_deletable.indexOf(s.entity.Material.Id) === -1);
      const invalid_rows = selectedRows.filter(s => material_ids_not_deletable.indexOf(s.entity.Material.Id) >= 0);
  
      if ($utils.isDefined(invalid_rows)) { failures.push(...invalid_rows) }
      if ($utils.isDefined(valid_rows)) { candidates.push(...valid_rows) }
  
      // no candidate
      if (candidates.length === 0) {
          const title = 'Delete material errors';
          const errorMessage = `Material(s) ${failures.map(c => c.entity.Material.LookupCode).join(',')} cannot be deleted`;
          const errorList = errors;
          await $shell.Materials.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
          const confirmCandidates = `Material(s) ${candidates.map(c => c.entity.Material.LookupCode).join(',')} - Once deleted, the materials(s) cannot be restored.`
  
          let confirm = false;
          if (failures.length >= 1) {
              const title = 'Some material(s) cannot be deleted';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.Materials.openConfirmationDialog(title, message);
          } else {
              const title = 'Delete the following materials(s)';
              const message = confirmCandidates;
              confirm = await $shell.Materials.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
              const processSuccess = [];
              const processFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
                      const flowParams = {
                          materialId: candidate.entity.Material.Id
                      }
                      const result = await $flows.Materials.delete_material_flow(flowParams);
  
                      processSuccess.push(candidate);
                  } catch (error) {
                      processFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Material ${candidate.entity.Material.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              // all succeeded
              if (processSuccess.length === candidates.length) {
                  const title = 'All material(s) deleted';
                  const message = `Material(s) ${processSuccess.map(c => c.entity.Material.LookupCode).join(',')} deleted`;
                  await $shell.Materials.openInfoDialog(title, message);
                  await $grid.refresh();
              } else {
                  // all failures
                  if (processFailures.length === candidates.length) {
                      const title = 'All material(s) failed to delete';
                      const message = `Material(s) ${processFailures.map(c => c.entity.Material.LookupCode).join(',')} could not be deleted`;
                      await $shell.Materials.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                  } else {
                      const title = 'Some materials could not be deleted';
                      const deleted = `Material(s) ${processSuccess.map(c => c.entity.LookupCode).join(',')} were deleted.`;
                      const errors = `The following material(s) could not be deleted: ${processFailures.map(c => c.entity.Material.LookupCode).join(',')}`;
                      const message = `${deleted} \r\n\r\n${errors}`;
                      await $shell.Materials.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
                  }
              }
          }
      }
  }
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.on_delete.control.readOnly = true;
  $grid.topToolbar.update.control.readOnly = true;
  
  for (let header in $grid.headers) {
      if (header !== 'description') {
          $grid.headers[header].width = 150;
      }
  }
  
  
  // Material catalog feature
  
  $grid.headers.source_catalog.hidden = true;
  
  if ($utils.isDefined($grid.inParams.projectId)) {
  
      let versionCheck = await $flows.Utilities.check_footprint_version({ minimumVersion: '24.10.25' });
  
      if (versionCheck.meetsMinimumVersion) {
  
          // @ts-ignore 
          const material_catalog = (await $datasources.Catalogs.ds_get_material_catalogs_by_project_id_top1.get({ project_id: $grid.inParams.projectId })).result;
          if ($utils.isDefined(material_catalog)) {
              $grid.headers.source_catalog.hidden = false;
  
          }
      }
  }
  
  const minVersionCheck = (await $flows.Utilities.check_footprint_version({ minimumVersion: '24.10.1' }));
  
  if (minVersionCheck.meetsMinimumVersion) {
      $grid.headers.allocation_strategy.hidden = true;
      $grid.vars.allocationStrategyWorkflows = (await $datasources.Materials.ds_get_allocation_strategy_workflows.get({})).result.map(s => ({ Id: s.Id, Name: s.Name }))
  } else {
      $grid.vars.allocationStrategyWorkflows = [];
      $grid.headers.allocation_strategy_workflow.hidden = true;
  }
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const selectedRowsCount = $grid.selectedRows.length;
  const selectedRows = $grid.selectedRows;
  
  if (selectedRowsCount > 0) {
  
  
      for (const row of selectedRows) {
          let versionCheck = await $flows.Utilities.check_footprint_version({ minimumVersion: '24.10.25' });
  
          if (versionCheck.meetsMinimumVersion) {
  
              // @ts-ignore 
              const material_catalog_details = (await $datasources.Catalogs.ds_get_material_catalog_details_by_material_id.get({ material_id: row.entity.MaterialId })).result;
              if ($utils.isDefined(material_catalog_details) && $utils.isDefined(material_catalog_details[0]?.MaterialCatalogSourceMaterialId)) {
                  $grid.topToolbar.on_delete.control.readOnly = true;
                  $grid.topToolbar.update.control.readOnly = true;
              }
              else {
  
                  $grid.topToolbar.on_delete.control.readOnly = false;
                  $grid.topToolbar.update.control.readOnly = false;
              }
          }
          else {
  
              $grid.topToolbar.on_delete.control.readOnly = false;
              $grid.topToolbar.update.control.readOnly = false;
          }
      }
  }
  else {
      $grid.topToolbar.on_delete.control.readOnly = true;
      $grid.topToolbar.update.control.readOnly = true;
  }
  }
  on_update(event = null) {
    return this.on_updateInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_updateInternal(
    $grid: FootprintManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.Materials.openErrorDialog('Material Update Error', 'No materials selected.');
      return;
  } else {
  
  
      const dialogResult = await $shell.FootprintManager.openmaterial_update_formDialog();
      const userConfirmed = dialogResult.confirm;
      const materialGroupId = dialogResult.materialGroupId;
      const shelfLifeSpan = dialogResult.shelfLifeSpan;
      const statusId = dialogResult.statusId;
      const allocationStrategyId = dialogResult.allocationStrategyId
      const allocationStrategyWorkflowId = dialogResult.allocationStrategyWorkflowId;
  
  
      let payload: any = {};
  
      if (userConfirmed) {
          for (const row of selectedRows) {
  
  
              if ($utils.isDefined(materialGroupId)) {
                  payload.MaterialGroupId = materialGroupId;
              }
              if (shelfLifeSpan) {
                  payload.ShelfLifeSpan = shelfLifeSpan;
              }
              if (statusId) {
                  payload.StatusId = statusId;
              }
              if ($utils.isDefined(allocationStrategyId)) {
                  payload.AllocationStrategyId = allocationStrategyId;
              }
              if ($utils.isDefined(allocationStrategyWorkflowId)) {
                  payload.AllocationStrategyWorkflowId = allocationStrategyWorkflowId;
              }
              await $flows.Utilities.crud_update_flow({ entitySet: 'Materials', id: row.entity.Material.Id, entity: payload });
          }
          await $grid.refresh();
      }
  }
  }
  on_export(event = null) {
    return this.on_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_exportInternal(
    $grid: FootprintManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_by_base_packaging_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  /**
   * Author: Ismail Saleh
   * Date: 2024-09-25
   * Description: Export functionality provided in a more reusable code
   */
  
  
  const settingsExcelExportLimit = $settings.FootprintManager.ExcelExportLimit;
  const serverMaxAllowedRecordsLimit: number = 5000;// could be changed base on what each request to the server can handle.
  const concurrentLimit = 5;//max concurrent requests
  const timeout = 500;//use it only if you want to set a delay between requests...
  // Initialize
  var workBook = $event;
  var recordsToExport = [];
  var fullDataSet: any[] = [];
  
  
  //parameters to be passed to dataset api call
  const baseParams = {
      ownerId: $grid.inParams.ownerId,
      projectId: $grid.inParams.projectId,
      fullTextSearch: $grid.fullTextSearch
  };
  
  //api call
  const dataApiCall = async (baseParams: any) => {
      return await $datasources.Materials.ds_materials_by_base_packaging_grid.getList(baseParams);
  };
  
  //records count api call
  const countApiCall = async (baseParams: any) => {
      const params = { ...baseParams, $top: 0 };
      return await $datasources.Materials.ds_materials_by_base_packaging_grid.getList(params);
  };
  
  //api call execution
  async function processApiCall(apiCall: (params: any) => Promise<any>, baseParams: any = {}, offset: number = 0, limit: number = 0): Promise<any> {
      const defaultParams = { $skip: offset, $top: limit };
      // Merge base, default, and additional params
      const params = { ...baseParams, ...defaultParams };
      return await apiCall(params);
  };
  
  //main funcion to handle concurrency in reagard of server and request limits
  async function processControlledApiRequests(totalRecords: number, requestLimit: number,serverLimit:number): Promise<any[]> {
      const totalBatches = Math.ceil(Math.min(totalRecords, serverLimit) / requestLimit);
      
      const result: any[] = [];
      const fetchPromiseQueue: Promise<any[]>[] = [];
  
      for (let i = 0; i < totalBatches; i++) {
          const offset = i * requestLimit;
          const limit = Math.min(requestLimit, serverLimit - (i * requestLimit));
  
          fetchPromiseQueue.push(processApiCall(dataApiCall, baseParams, offset, limit));
  
          //process promiseQueue once reached the limit then clear queue for the next loop round...
          if (fetchPromiseQueue.length === concurrentLimit) { 
              result.push(...await Promise.all(fetchPromiseQueue));
              fetchPromiseQueue.length = 0; 
          }
      }
  
      // Process any remaining requests after the loop
      if (fetchPromiseQueue.length) result.push(...await Promise.all(fetchPromiseQueue));
  
      return result;
  }
  
  
  // Set Date/Time Formats
  const dateFormat = `${$settings.FootprintManager.DateFormat}`;
  
  function getAge(date: any): number {
      var diffInDays: number;
      if ($utils.isDefined(date)) {
          const currentDate = new Date();
          const receiveDate = new Date(date);
          const diffInMS = currentDate.getTime() - receiveDate.getTime();
          diffInDays = Math.floor(diffInMS / (1000 * 60 * 60 * 24));
      }
      return diffInDays;
  }
  
  try {
  
      //Handle user selected rows only.
      if ($grid.selectedRows.length > 0) {
          //$grid.rows[0].cells.height.displayControl.text;
          // Compile all data into JSON
          for (let row of $grid.selectedRows) {
              let project = "";
              let owner = "";
  
              if (row.entity.Material?.Project?.LookupCode === row.entity.Material?.Project?.Name) {
                  project = row.entity.Material?.Project?.LookupCode
              } else {
                  project = row.entity.Material?.Project?.LookupCode + ' ' + row.entity.Material?.Project?.Name
              }
  
              // Apply custom owner string logic
              if (row.entity.Material?.Project?.Owner?.LookupCode === row.entity.Material?.Project?.Owner?.Name) {
                  owner = row.entity.Material?.Project?.Owner?.LookupCode
              } else {
                  owner = row.entity.Material?.Project?.Owner?.LookupCode + ' ' + row.entity.Material?.Project?.Owner?.Name
              }
  
  
              recordsToExport.push({
                  "Lookup": row.entity.Material?.LookupCode,
                  "Description": row.entity.Material?.Description,
                  "Base UOM": row.entity.Packaging?.ShortName,
                  "Owner": owner,//
                  "Project": project,//
                  "Status": row.entity.Material?.Status?.Name,
                  "Group": row.entity.Material?.MaterialGroup?.Name,
                  "Allocation strategy": row.entity.Material?.AllocationStrategy?.Name,
                  "Lot controlled": row.entity.Material.ControllerTypeId == 2 || row.entity.Material.ControllerTypeId == 4 ? true : false,//
                  "Serial controlled": row.entity.Material.ControllerTypeId == 3 || row.entity.Material.ControllerTypeId == 4 ? true : false,
                  "Fixed weight": row.entity.Material?.IsFixedWeight,
                  "Fixed volume": row.entity.Material?.IsFixedVolume,
                  "Fixed dimension": row.entity.Material?.IsFixedLength,
                  "Length": row.entity.Length?.toString(),
                  "Width": row.entity.Width?.toString(),
                  "Height": row.entity.Height?.toString(),
                  "Weight": row.entity.Weight?.toString(),
                  "Shipping weight": row.entity.ShippingWeight?.toString(),
                  "Volume": row.entity.Volume?.toString(),
                  "Shipping volume": row.entity.ShippingVolume?.toString(),
                  "Pallet height": row.entity.PalletHigh?.toString(),
                  "Pallet tie": row.entity.PalletTie?.toString(),
                  "UPC": row.entity.UpcCode,
                  "Shelf life": row.entity.Material?.ShelfLifeSpan?.toString(),
                  "shippable container": row.entity.UseAsShippingContainer
  
              });
          }
          var workSheet = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, workSheet, "MaterialExport");
      }
      //take all rows in the dataset with applied filters.
      else {
  
          const { totalCount: requestedRecordsCount } = await countApiCall(baseParams);
  
          if (requestedRecordsCount > settingsExcelExportLimit) {
              await $shell.FootprintManager.openInfoDialog(`Export limitation of ${settingsExcelExportLimit} exceeded`, `Excel will only export ${settingsExcelExportLimit} records`);
          }
  
          const responses = await processControlledApiRequests(requestedRecordsCount, serverMaxAllowedRecordsLimit,settingsExcelExportLimit);
          responses.forEach(apiResponse => {
              fullDataSet.push(...apiResponse.result);
          });
  
          //await $shell.FootprintManager.openInfoDialog(` Array count `, `${fullDataSet.length}`);
          // Compile all data into JSON
          for (let record of fullDataSet) {
  
              let project = "";
              let owner = "";
  
              if (record.Material?.Project?.LookupCode === record.Material?.Project?.Name) {
                  project = record.Material?.Project?.LookupCode
              } else {
                  project = record.Material?.Project?.LookupCode + ' ' + record.Material?.Project?.Name
              }
  
              // Apply custom owner string logic
              if (record.Material?.Project?.Owner?.LookupCode === record.Material?.Project?.Owner?.Name) {
                  owner = record.Material?.Project?.Owner?.LookupCode
              } else {
                  owner = record.Material?.Project?.Owner?.LookupCode + ' ' + record.Material?.Project?.Owner?.Name
              }
  
              recordsToExport.push({
                  "Lookup": record.Material?.LookupCode,
                  "Description": record.Material?.Description,
                  "Base UOM": record.Packaging?.ShortName,
                  "Owner": owner,//
                  "Project": project,//
                  "Status": record.Material?.Status?.Name,
                  "Group": record.Material?.MaterialGroup?.Name,
                  "Allocation strategy": record.Material?.AllocationStrategy?.Name,
                  "Lot controlled": record.Material?.ControllerTypeId == 2 || record.Material?.ControllerTypeId == 4 ? true : false,//
                  "Serial controlled": record.Material?.ControllerTypeId == 3 || record.Material?.ControllerTypeId == 4 ? true : false,
                  "Fixed weight": record.Material?.IsFixedWeight,
                  "Fixed volume": record.Material?.IsFixedVolume,
                  "Fixed dimension": record.Material?.IsFixedLength,
                  "Length": record.Length?.toString(),
                  "Width": record.Width?.toString(),
                  "Height": record.Height?.toString(),
                  "Weight": record.Weight?.toString(),
                  "Shipping weight": record.ShippingWeight?.toString(),
                  "Volume": record.Volume?.toString(),
                  "Shipping volume": record.ShippingVolume?.toString(),
                  "Pallet height": record.PalletHigh?.toString(),
                  "Pallet tie": record.PalletTie?.toString(),
                  "UPC": record.UpcCode,
                  "Shelf life": record.Material?.ShelfLifeSpan?.toString(),
                  "shippable container": record.UseAsShippingContainer
  
              });
          }
          var workSheet = $utils.excel.json_to_sheet(recordsToExport);
          $utils.excel.book_append_sheet(workBook, workSheet, "MaterialExport");
         
      }
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      throw new Error(errorMessage);
  }
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export(wb);

    writeExcelFile(wb, 'FootprintManager_materials_by_base_packaging_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
